/** Admin (back-office) contracts — docs/07-Admin/. */
// ─── Webhooks (ADR-032) ─────────────────────────────────────────────────────
/** Where a destination's events go (ADR-110): a signed JSON webhook, a Slack channel, or a Telegram chat. */
export const WEBHOOK_KINDS = ['JSON', 'SLACK', 'TELEGRAM'];
/** The customer messages staff may send again (ADR-059). */
export const ORDER_NOTIFICATIONS = [
    'order.placed',
    'order.paid',
    'order.shipped',
    'order.ready_for_pickup',
    'order.cancelled',
];
//# sourceMappingURL=admin.js.map